module.exports = __webpack_public_path__ + "img/microscopio@2x.c8ad37f3.png";